import { useFormContext } from 'react-hook-form'
import { ReactNode } from 'react'
import { FlexColumn, FlexRow } from '../../../atoms/layout/Flex'
import Label from '../../../atoms/display/Label'
import RadioControl from '../../../atoms/inputs/RadioControl'
import TextField from '../../../atoms/inputs/TextField'
import NumberControl from '../../../atoms/inputs/NumberControl'
import Divider from '../../../atoms/display/Divider'
import { VisitorRegistrationFormParams } from '../../../../types/Company'

function FormRow(props: { text: string; subText?: string; children: ReactNode }) {
  const { text, subText, children } = props
  return (
    <FlexColumn>
      <FlexRow align="center">
        <FlexColumn width={320} space={0}>
          <Label text={text} />
          {subText && <Label text={subText} variant="caption" />}
        </FlexColumn>
        {children}
      </FlexRow>
      <Divider />
    </FlexColumn>
  )
}

export default function VisitorRegistrationSurveysForm() {
  const form = useFormContext<VisitorRegistrationFormParams>()
  const { errors } = form.formState

  return (
    <FlexColumn>
      <Label text="代表者がアンケートにお応えください" variant="subtitle" />
      <FormRow text="（個人事業主の方に質問）あなたは一人親方ですか">
        <RadioControl
          items={[
            { value: 1, label: '法人' },
            { value: 2, label: '個人' },
          ]}
          control={form.control}
          name="survey1"
          row
          error={errors.survey1?.message}
        />
      </FormRow>
      <FormRow text="労働者は何人いますか">
        <RadioControl
          items={[
            { value: 1, label: '5人以上' },
            { value: 2, label: '5人未満' },
          ]}
          control={form.control}
          name="survey2"
          row
          error={errors.survey2?.message}
        />
      </FormRow>
      <FormRow text="使用する労働者数が年間延べ100人以上となりますか">
        <RadioControl
          items={[
            { value: 1, label: 'はい' },
            { value: 2, label: 'いいえ' },
          ]}
          control={form.control}
          name="survey3"
          row
          error={errors.survey3?.message}
        />
      </FormRow>
      <FormRow text="労災保険に特別加入していますか">
        <RadioControl
          items={[
            { value: 1, label: '加入' },
            { value: 2, label: '未加入' },
          ]}
          control={form.control}
          name="survey4"
          row
          error={errors.survey4?.message}
        />
      </FormRow>
      <FormRow text="法定外労災補償制度に加入していますか">
        <RadioControl
          items={[
            { value: 1, label: '加入' },
            { value: 2, label: '未加入' },
          ]}
          control={form.control}
          name="survey5"
          row
          error={errors.survey5?.message}
        />
      </FormRow>
      <FormRow text="健康保険に加入していますか" subText="加入している場合は健康保険の名称を記入してください">
        <FlexColumn space={0}>
          <RadioControl
            items={[
              { value: 1, label: '加入' },
              { value: 2, label: '未加入' },
            ]}
            control={form.control}
            name="survey6"
            row
            error={errors.survey6?.message}
          />
          <TextField
            register={form.register('survey6Name')}
            placeholder="協会けんぽ"
            error={errors.survey6Name?.message}
          />
        </FlexColumn>
      </FormRow>
      <FormRow text="年金保険に加入していますか" subText="加入している場合は年金保険の名称を記入してください">
        <FlexColumn space={0}>
          <RadioControl
            items={[
              { value: 1, label: '加入' },
              { value: 2, label: '未加入' },
            ]}
            control={form.control}
            name="survey7"
            row
            error={errors.survey7?.message}
          />
          <TextField
            register={form.register('survey7Name')}
            placeholder="厚生年金"
            error={errors.survey7Name?.message}
          />
        </FlexColumn>
      </FormRow>
      <FormRow text="雇用保険に加入していますか">
        <RadioControl
          items={[
            { value: 1, label: '加入' },
            { value: 2, label: '未加入' },
          ]}
          control={form.control}
          name="survey8"
          row
          error={errors.survey8?.message}
        />
      </FormRow>
      <FormRow text="賠償責任保険に加入していますか">
        <RadioControl
          items={[
            { value: 1, label: '加入' },
            { value: 2, label: '未加入' },
          ]}
          control={form.control}
          name="survey9"
          row
          error={errors.survey9?.message}
        />
      </FormRow>
      <FormRow text="建設現場で働き始めたのは何年頃ですか">
        <FlexRow wrap align="center">
          <Label text="西暦" />
          <NumberControl
            control={form.control}
            name="survey10"
            suffix="年"
            size="xs"
            error={errors.survey10?.message}
          />
        </FlexRow>
      </FormRow>
      <FormRow text="毎年健康診断を受けていますか">
        <RadioControl
          items={[
            { value: 1, label: 'はい' },
            { value: 2, label: 'いいえ' },
          ]}
          control={form.control}
          name="survey11"
          row
          error={errors.survey11?.message}
        />
      </FormRow>
      <FormRow text="労働者を雇入する際に雇入時の全項目の健康診断並びに毎年1回の定期健康診断を実施し結果票を5年間保管していますか">
        <RadioControl
          items={[
            { value: 1, label: 'はい' },
            { value: 2, label: 'いいえ' },
          ]}
          control={form.control}
          name="survey12"
          row
          error={errors.survey12?.message}
        />
      </FormRow>
      <FormRow text="労働者に対して送り出し教育を実施していますか">
        <RadioControl
          items={[
            { value: 1, label: 'はい' },
            { value: 2, label: 'いいえ' },
          ]}
          control={form.control}
          name="survey13"
          row
          error={errors.survey13?.message}
        />
      </FormRow>
      <FormRow text="労働者に対して運転免許停止など処分の有無を適宜確認していますか">
        <RadioControl
          items={[
            { value: 1, label: 'はい' },
            { value: 2, label: 'いいえ' },
          ]}
          control={form.control}
          name="survey14"
          row
          error={errors.survey14?.message}
        />
      </FormRow>
      <FormRow text="工事を下請に任せることはありますか">
        <RadioControl
          items={[
            { value: 1, label: 'はい' },
            { value: 2, label: 'いいえ' },
          ]}
          control={form.control}
          name="survey15"
          row
          error={errors.survey15?.message}
        />
      </FormRow>
    </FlexColumn>
  )
}
